import ResourceTimingCompression from '../../lib/resourcetiming/compression';
import getWebGLStat from '../../lib/webglstat';
import Ajax from '../../utils/ajax';
import { assignDefaultData } from '../../utils/func';
import logger from '../../utils/logger';
import SystemOptions from '../../utils/options';

export default async function () {
  const options = SystemOptions.getInstance().getOptions();
  // 获取页面加载数据，获取WebGL数据
  const resource =
    options.initPagePerformance && options.getPagePerformance && window.performance.getEntriesByType
      ? ResourceTimingCompression.compressResourceTiming(window, window.performance.getEntriesByType('resource'))
      : { };
  let webgl = { };
  if (options.webglStat) {
    try {
      webgl = getWebGLStat();
    } catch (e) {
      //
    }
    if (options.debug) {
      logger.info('WebglInfo: ' + JSON.stringify(webgl));
    }
  } else {
    if (options.debug) {
      logger.info('can\'t get webgl info');
    }
  }
  const data = {
    page: window.performance.timing,
    resource,
    stat: {
      webgl,
    },
  };
  await Ajax.send(assignDefaultData(data, options), options.performanceApiUrl);
}
